import React from "react";
import SpinnerOverlay from "src/components/common/SpinnerOverlay";
import PDAHeader from "src/components/common/Header";
import usePDA1121_R01Store from "./usePDA1121_R01Store";
import { usePDAContainer } from "src/hooks/usePDAContainer";
import PDA1121_R01Content from "./PDA1121_R01Content";

import PDA1121_R01Search from "./PDA1121_R01Search";
import PDA1121_R01Table from "./PDA1121_R01Table";
import PDA1121_R01Info from "./PDA1121_R01Info";
import PDA1121_R01DetailTable from "./PDA1121_R01DetailTable";

interface Props {
  menuNm: string;
  menuCd?: string;
  onBack?: () => void;
}

const PDA1121_R01Container = ({ menuNm, menuCd, onBack }: Props) => {
  const { loading, reset, showList, orderList } = usePDA1121_R01Store();
  const { handleMenuClick } = usePDAContainer(reset);
  const { handleSearch, handleSelectOrder, handleBackToList } = PDA1121_R01Content();

  return (
    <div className="w-full h-screen flex flex-col bg-white fixed inset-0">
      <PDAHeader
        menuNm={menuNm}
        menuCd={menuCd}
        onBack={showList ? onBack : handleBackToList}
        onMenuClick={handleMenuClick}
      />
      <div className="flex-1 overflow-hidden">
        {showList ? (
          <div className="h-full flex flex-col">
            <PDA1121_R01Search onSearch={handleSearch} />
            <div className="flex-1 overflow-hidden">
              <PDA1121_R01Table orderList={orderList} onSelectOrder={handleSelectOrder} />
            </div>
          </div>
        ) : (
          <div className="h-full flex flex-col">
            <PDA1121_R01Info />
            <div className="flex-1 overflow-hidden">
              <PDA1121_R01DetailTable />
            </div>
          </div>
        )}
      </div>
      {loading && <SpinnerOverlay text="처리 중..." />}
    </div>
  );
};

export default PDA1121_R01Container;
